export interface AddonCache {
    enabled: Array<string>;
}
